import { render, staticRenderFns } from "./UnconfirmedAccountBanner.vue?vue&type=template&id=33365e49&scoped=true&"
import script from "./UnconfirmedAccountBanner.vue?vue&type=script&lang=js&"
export * from "./UnconfirmedAccountBanner.vue?vue&type=script&lang=js&"
import style0 from "./UnconfirmedAccountBanner.vue?vue&type=style&index=0&id=33365e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33365e49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBanner,VBtn,VIcon})
